import { render, staticRenderFns } from "./productExcellentCase.vue?vue&type=template&id=712af6b6&scoped=true&"
import script from "./productExcellentCase.vue?vue&type=script&lang=js&"
export * from "./productExcellentCase.vue?vue&type=script&lang=js&"
import style0 from "./productExcellentCase.vue?vue&type=style&index=0&id=712af6b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712af6b6",
  null
  
)

export default component.exports